// Advance Cash — Yasal metinler (Kullanım Koşulları + Gizlilik Politikası)
// Kaliteli SaaS + KVKK uyumlu içerik.
//
// Versiyon yönetimi: Metinlerde önemli bir değişiklik yapıldığında versiyonu
// artırın. Kayıt anında hangi versiyonun kabul edildiği DB'ye yazılır.
// Kullanıcı eski sürüm kabul etmişse, yeni sürüm için tekrar onay istenir.
export const TERMS_VERSION = '2026-07-01.v1';
export const PRIVACY_VERSION = '2026-07-01.v1';

export const TERMS_TITLE = 'Kullanım Koşulları';

export const TERMS_CONTENT = `
# Advance Cash Kullanım Koşulları

**Son güncelleme:** 1 Temmuz 2026

Advance Cash ("Platform", "biz", "bize") hizmetlerini kullanarak aşağıdaki koşulları kabul etmiş olursunuz. Lütfen dikkatlice okuyun.

## 1. Hizmet Tanımı
Advance Cash; şirket avans ve masraf yönetimi, harcama takibi, muhasebe entegrasyonu ve raporlama için bulut tabanlı bir SaaS platformudur. Hizmet, tarayıcı ve/veya mobil arayüzler üzerinden sunulur.

## 2. Hesap Oluşturma ve Kullanım
- Hesap açan kişi (şirket temsilcisi veya bireysel kullanıcı) verdiği bilgilerin doğruluğunu taahhüt eder.
- Hesabınızın kullanıcı adı ve şifresinin güvenliği tamamen size aittir. Şifrenizin başkalarıyla paylaşılmasından kaynaklanan zararlarda platformun sorumluluğu yoktur.
- 18 yaşından küçük gerçek kişiler bu hizmeti kullanamaz.
- Tek bir gerçek kişi/tüzel kişi başına birden fazla ücretsiz deneme hesabı açmak yasaktır.

## 3. Ücretsiz Deneme ve Abonelik
- Tüm planlarda 14 gün ücretsiz deneme süresi tanınır. Deneme süresince kredi kartı bilgisi istenmez.
- Deneme süresi sonunda hesabınız otomatik olarak aboneliğe geçmez; ödeme yapılana kadar kısıtlı moda alınır.
- Abonelik ücretleri Ultra Admin panelinde ilan edilen güncel fiyatlardan tahsil edilir.
- Aylık abonelikler, iptal edilmedikçe her ay otomatik yenilenir.
- İptal işleminde, cari döngü sonuna kadar hizmet devam eder; kalan gün için iade yapılmaz.

## 4. Ödemeler ve Faturalar
- Ödemeler Stripe altyapısı üzerinden güvenli olarak alınır. Kart bilgileriniz bizim sunucularımızda saklanmaz.
- Fatura, ödeme sonrasında e-posta adresinize otomatik gönderilir ve panel içinden indirilebilir.
- Yanlış banka bilgisi, ödeme reddi veya ters ibraz gibi durumlarda hesabınız pasife alınabilir.

## 5. Veri Sahipliği ve Yedekleme
- Platform üzerinden girdiğiniz tüm veriler (harcamalar, belgeler, işletme bilgileri vb.) SİZE aittir. Biz yalnızca hizmetin sunulması amacıyla bu verilere işleme hakkı kazanırız.
- Aboneliğiniz sona erdiğinde veya hesabınızı kapatmayı talep ettiğinizde, tüm verilerinizi CSV/JSON formatında dışa aktarma hakkına sahipsiniz. Talep tarihinden itibaren 30 gün süreyle veri saklanır, sonrasında silinir.
- Hizmet için düzenli otomatik yedekler alırız; ancak siz de kritik verilerinizin kendi yedeğini almanızı öneririz.

## 6. Kullanıcı Yükümlülükleri — Yapılamayacaklar
Aşağıdaki eylemler kesinlikle yasaktır:
- Platformu kanuna aykırı, dolandırıcılık veya kara para aklama gibi amaçlarla kullanmak.
- Başka bir kullanıcının hesabına yetkisiz erişim sağlamaya çalışmak.
- Otomatik araçlar (bot, scraper) ile aşırı yük oluşturmak.
- Fikri mülkiyet haklarını ihlal eden içerik yüklemek.
- Platformun kaynak kodunu tersine mühendislik yapmak, çözümlemek veya kopyalamak.

Bu maddelere aykırı hareket eden hesaplar herhangi bir bildirim yapılmaksızın askıya alınabilir veya kalıcı olarak kapatılabilir.

## 7. Fikri Mülkiyet
Advance Cash markası, logosu, kaynak kodu, tasarımı ve tüm yazılım varlıkları platform sağlayıcısına aittir. Kullanıcıya hizmet süresince yalnızca sınırlı, devredilemez bir kullanım lisansı verilir.

## 8. Sorumluluğun Sınırlandırılması
Yasa gereği zorunlu olmadıkça, Advance Cash:
- Dolaylı, tesadüfi veya sonuç niteliğindeki zararlardan sorumlu değildir.
- Kesintisiz veya hatasız hizmet garanti etmez (ancak %99,5 uptime hedefimiz vardır).
- Muhasebe / vergi / hukuki tavsiye vermez. Kararlarınızı almadan önce lütfen kendi mali müşavirinize danışın.
- Toplam sorumluluğumuz, olayın gerçekleştiği ay için ödemiş olduğunuz abonelik ücreti ile sınırlıdır.

## 9. Değişiklikler
Bu koşullarda değişiklik yapma hakkımızı saklı tutarız. Önemli değişiklikleri en az 15 gün önceden e-posta veya panel içi bildirim ile duyururuz. Değişikliği kabul etmemeniz durumunda aboneliğinizi iptal edebilirsiniz.

## 10. Uyuşmazlıkların Çözümü
Bu koşullardan doğan uyuşmazlıklar Türk hukukuna tabidir. Anlaşmazlık halinde İstanbul Anadolu Adliyesi mahkemeleri ve icra daireleri yetkilidir. Taraflar ilk olarak iyi niyetle uzlaşmayı dener.

## 11. İletişim
Sorularınız için: **destek@advancecash.io**
Yasal bildirimler için: **legal@advancecash.io**

Bu koşulları okuyup anladığınızı ve kabul ettiğinizi teyit etmeniz istenmektedir.
`.trim();

export const PRIVACY_TITLE = 'Gizlilik Politikası';

export const PRIVACY_CONTENT = `
# Advance Cash Gizlilik Politikası (KVKK ve GDPR Uyumlu)

**Son güncelleme:** 1 Temmuz 2026

Bu politika; Advance Cash'in kişisel verilerinizi nasıl topladığını, işlediğini, sakladığını ve haklarınızı nasıl kullanabileceğinizi açıklar. 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve Avrupa GDPR düzenlemesine tam uyumluyuz.

## 1. Veri Sorumlusu
Advance Cash platformunun veri sorumlusu, Advance Cash Yazılım A.Ş.'dir. İletişim: **kvkk@advancecash.io**

## 2. Topladığımız Kişisel Veriler

### a) Hesap oluştururken sizden alınan bilgiler
- Ad, soyad
- E-posta adresi
- Telefon numarası (opsiyonel)
- Şirket adı, vergi no, adres (kurumsal hesaplarda)
- Şifre (hash'lenmiş formatta saklanır, ham şifre asla)

### b) Kullanım sırasında otomatik toplanan bilgiler
- IP adresi, tarayıcı tipi, işletim sistemi
- Oturum açma/kapama zamanları
- Kullanılan modüller ve tıklama örüntüleri (yalnızca ürünü iyileştirmek için)

### c) Hizmet için girdiğiniz iş verileri
- Harcama kayıtları, fiş görüntüleri, işletme bilgileri
- Kredi kartı ekstresi verileri (bilgiler siz yüklerseniz)
- **Not:** Kredi kartı numaraları asla bizim sunucularımızda saklanmaz. Ödemeler Stripe altyapısı üzerinden yapılır.

## 3. Verilerinizi İşleme Amaçlarımız
- Sözleşmenin ifası (hizmeti sunmak, ödemeleri işlemek, fatura düzenlemek)
- Yasal yükümlülüklerin yerine getirilmesi (vergi, muhasebe, mali suç önleme)
- Meşru menfaat (dolandırıcılık önleme, güvenlik, hizmet iyileştirme)
- Açık rıza gerektiren durumlar (pazarlama e-postaları — istediğiniz zaman abonelikten çıkabilirsiniz)

## 4. Verilerinizi Kimlerle Paylaşırız
Verileriniz **satılmaz**. Yalnızca aşağıdaki üçüncü taraflarla paylaşılır ve her biri kendi gizlilik ve güvenlik sözleşmesi altındadır:
- **Stripe** — ödeme işleme (kart verisi)
- **SendGrid** — otomatik e-posta gönderimi
- **MongoDB Atlas / AWS** — bulut altyapı sağlayıcıları
- **Yetkili resmi kurumlar** — yasal bir talep olduğunda
- **Muhasebeciniz** — yalnızca sizin talebiniz üzerine ZIP raporu olarak

## 5. Verilerin Saklama Süresi
- Aktif hesaplar için: aboneliğiniz devam ettiği sürece
- Pasif hesaplar: son işlemden 3 yıl sonra otomatik silme
- Yasal saklama zorunluluğu olan veriler (fatura, vergi): 10 yıl (VUK gereği)
- Silme talebiniz üzerine: 30 gün grace period, sonra kalıcı silme

## 6. Verilerin Güvenliği
- Tüm veri iletimi TLS 1.3 üzerinden şifrelenir
- Şifreler bcrypt / SHA-256 ile hash'lenir; hiçbir zaman ham metin saklanmaz
- Veri tabanı at-rest AES-256 ile şifrelenir
- İki faktörlü kimlik doğrulama (2FA) desteklenir
- Düzenli sızma testleri ve güvenlik denetimleri yapılır
- Bir güvenlik ihlali durumunda 72 saat içinde bildirim yapılır (KVKK md. 12 gereği)

## 7. KVKK Kapsamındaki Haklarınız
KVKK md. 11 gereği aşağıdaki haklara sahipsiniz:
- **Bilgi alma:** Kişisel verilerinizin işlenip işlenmediğini öğrenme
- **Erişim:** Hangi verilerin işlendiğini talep etme
- **Düzeltme:** Yanlış/eksik bilgilerin düzeltilmesini isteme
- **Silme:** Verilerin silinmesini veya yok edilmesini talep etme
- **Aktarım:** Verilerinizi başka bir hizmete taşımak için makine okunabilir formatta talep etme
- **İtiraz:** Otomatik işlemlere veya belirli kullanımlara itiraz etme
- **Zarar tazmini:** Verilerin kanuna aykırı işlenmesi nedeniyle uğradığınız zararın tazminini isteme

Haklarınızı kullanmak için **kvkk@advancecash.io** adresine e-posta atabilir veya panelinizde "Hesap → KVKK Talebi" bölümünü kullanabilirsiniz. Talebiniz en geç 30 gün içinde yanıtlanır.

## 8. Çerezler (Cookies)
Platform, oturum yönetimi ve tercih hatırlama için çerez kullanır. Analytics çerezleri açık rıza gerektirir ve panel ayarlarından kapatılabilir.

- **Zorunlu çerezler:** Oturum, güvenlik, dil tercihi
- **Analitik çerezler:** Kullanım örüntüleri (Google Analytics — anonimleştirilmiş)
- **Pazarlama çerezleri:** Yok

## 9. Uluslararası Veri Transferi
Verileriniz temelde Türkiye'de veya AB üyesi ülkelerde saklanır. Bazı hizmet sağlayıcılarımız (Stripe, MongoDB Atlas) verileri ABD'de barındırabilir. Bu transferler için AB Standart Sözleşme Maddeleri (SCC) kullanılır.

## 10. Çocukların Gizliliği
18 yaşından küçük kullanıcıların hizmetimize kayıt olmasına izin verilmez. 18 yaşından küçük olduğunu tespit ettiğimiz hesaplar derhal kapatılır.

## 11. Politika Değişiklikleri
Bu politikada yapılan önemli değişiklikler en az 15 gün önceden panel içi ve e-posta ile duyurulur.

## 12. İletişim & Şikayet
- **KVKK sorumlusu:** kvkk@advancecash.io
- **Destek:** destek@advancecash.io
- **Şikayet mercii:** Kişisel Verileri Koruma Kurumu (kvkk.gov.tr)

Bu politikayı okuyup anladığınızı ve kabul ettiğinizi teyit etmeniz istenmektedir.
`.trim();
